import { Controller } from "@hotwired/stimulus"

// CONEK-8571 — turns a `scan-resolve:scanner-unavailable` dispatch into a
// visible sonner toast so the broken-wiring branch of scan-resolve#open is
// user-visible, not console-only. Only reachable when the host wrapper
// mounts the scan button WITHOUT the iot--qr-scan controller (today the
// wrapper always pairs the two, so this is defence in depth).
export default class extends Controller {
  static values = { message: String }

  async show() {
    try {
      const { toast } = await import("sonner")
      toast.error(this.messageValue)
    } catch (_err) {
      // Last resort: a native alert so the operator still sees it even if
      // sonner isn't on the page.
      window.alert(this.messageValue)
    }
  }
}
